import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { COLORS } from '../../constants/theme';

const Section = styled.section`
  padding: 6rem 2rem;
  background: rgba(0, 0, 0, 0.3);
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  text-align: center;
  margin-bottom: 3rem;
  color: ${COLORS.pink};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid ${COLORS.whiteSubtle};
  .quote {
    font-style: italic;
    margin-bottom: 1.5rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
  }
  .author { display: flex; align-items: center; gap: 1rem; }
  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: ${COLORS.gradientPrimary};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
  .details {
    h4 { color: ${COLORS.cyan}; margin-bottom: 0.25rem; }
    p { color: rgba(255, 255, 255, 0.6); font-size: 0.9rem; }
  }
`;

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };

function TestimonialsSection() {
  const { t } = useTranslation();

  const testimonials = [
    { quoteKey: 'landing.testimonial1Quote', nameKey: 'landing.testimonial1Name', roleKey: 'landing.testimonial1Role', initials: 'SK', delay: 0 },
    { quoteKey: 'landing.testimonial2Quote', nameKey: 'landing.testimonial2Name', roleKey: 'landing.testimonial2Role', initials: 'JD', delay: 0.2 },
    { quoteKey: 'landing.testimonial3Quote', nameKey: 'landing.testimonial3Name', roleKey: 'landing.testimonial3Role', initials: 'MP', delay: 0.4 }
  ];

  return (
    <Section id="testimonials">
      <Title>{t('landing.testimonialsTitle')}</Title>
      <Grid>
        {testimonials.map((item, index) => (
          <Card key={index} {...fadeUp} transition={{ duration: 0.5, delay: item.delay }}>
            <p className="quote">"{t(item.quoteKey)}"</p>
            <div className="author">
              <div className="avatar">{item.initials}</div>
              <div className="details">
                <h4>{t(item.nameKey)}</h4>
                <p>{t(item.roleKey)}</p>
              </div>
            </div>
          </Card>
        ))}
      </Grid>
    </Section>
  );
}

export default TestimonialsSection;
